import axios, {
  AxiosError,
  AxiosHeaders,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from 'axios';
import { store } from '@store/store';
import { adminLoggedOut, adminTokenReceived } from '@store/adminAuth/adminAuth-slice';

export const adminApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  timeout: 30_000,
});
adminApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = store.getState().adminAuth.accessToken;
  if (token) {
    if (config.headers && typeof (config.headers as any).set === 'function')
      (config.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`);
    else config.headers = { ...(config.headers as any), Authorization: `Bearer ${token}` };
  }
  return config;
});
let refreshing: Promise<string | null> | null = null;
adminApi.interceptors.response.use(
  response => response,
  async (error: AxiosError) => {
    const original = error.config as (AxiosRequestConfig & { _adminRetry?: boolean }) | undefined;
    if (
      !original ||
      error.response?.status !== 401 ||
      original._adminRetry ||
      String(original.url).includes('/admin-auth/')
    )
      return Promise.reject(error);
    original._adminRetry = true;
    refreshing ??= axios
      .post(`${process.env.REACT_APP_API_URL}/admin-auth/refresh`, {}, { withCredentials: true })
      .then(({ data }) => {
        store.dispatch(adminTokenReceived(data));
        return data.access_token as string;
      })
      .catch(() => {
        store.dispatch(adminLoggedOut());
        return null;
      })
      .finally(() => {
        refreshing = null;
      });
    return (await refreshing) ? adminApi(original) : Promise.reject(error);
  },
);
